// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3yr-T","title":"AfterFrontImage_title__BAEbt"};